import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import socket from "../tools/socke";

import ModalSancion from "./Modal";
import Sancion from "./Sancion";

import "./Sancionaa.css";

const ObtieneSancionesUsuario = ({ refresca }) => {
  const Usuario = ObtieneDatosCookies();

  // ============================================================
  // ESTADOS
  // ============================================================

  const [
    listadoSanciones,
    setListadoSanciones,
  ] = useState([]);

  const [cargando, setCargando] = useState(false);

  const [
    sancionSeleccionada,
    setSancionSeleccionada,
  ] = useState(null);

  const [
    veoDatosSancion,
    setVeoDatosSancion,
  ] = useState(false);

  const [error, setError] = useState("");

  // ============================================================
  // TOKEN
  // ============================================================

  const obtenerToken = () => {
    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;

    return btoa(
      `${username}:${password}`
    );
  };

  // ============================================================
  // OBTENER MIS SANCIONES
  // ============================================================

  const obtieneMisSanciones =
    useCallback(async () => {
      if (!Usuario?.id) {
        return;
      }

      try {
        setCargando(true);
        setError("");

        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/Ncadetes/devuelveSancionPorSancionante/${Usuario.id}`
        );

        setListadoSanciones(
          Array.isArray(response?.data)
            ? response.data
            : []
        );
      } catch (error) {
        console.error(
          "Error obteniendo sanciones propias:",
          error
        );

        setListadoSanciones([]);

        setError(
          "No se pudieron obtener las sanciones generadas por su usuario."
        );
      } finally {
        setCargando(false);
      }
    }, [Usuario?.id]);

  // ============================================================
  // CERRAR MODAL
  // ============================================================

  const cerrarModal = () => {
    setVeoDatosSancion(false);
    setSancionSeleccionada(null);
  };

  // ============================================================
  // ANULAR SANCION
  // ============================================================

  const anulaSancion = async (sancion) => {
    try {
      const confirmacion = await Swal.fire({
        title: "¿Anular sanción?",
        text:
          "La sanción quedará anulada y dejará de continuar en el circuito disciplinario.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          "Sí, anular sanción",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#b42318",
      });

      if (!confirmacion.isConfirmed) {
        return;
      }

      const token = obtenerToken();

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        {
          estado: "Anulada",
        },
        {
          headers: {
            Authorization:
              `Basic ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          title: "Sanción anulada",
          text: `La sanción del cadete DNI ${sancion.cadeteDni} fue anulada correctamente.`,
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        cerrarModal();
        obtieneMisSanciones();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo anular",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error anulando sanción:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo anular la sanción.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  // ============================================================
  // PASAR A CONFIRMAR
  // ============================================================

  const pasaAConfirmarSancion =
    async (sancion) => {
      try {
        const confirmacion =
          await Swal.fire({
            title:
              "Enviar a confirmación",
            text:
              "La sanción será remitida a la superioridad para su control y resolución.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText:
              "Enviar a confirmar",
            cancelButtonText:
              "Cancelar",
            confirmButtonColor:
              "#315f64",
          });

        if (
          !confirmacion.isConfirmed
        ) {
          return;
        }

        const token =
          obtenerToken();

        const response =
          await axios.post(
            `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
            {
              estado:
                "Para Confirmar",
            },
            {
              headers: {
                Authorization:
                  `Basic ${token}`,
              },
            }
          );

        if (
          response?.data?.success
        ) {
          await Swal.fire({
            title:
              "Sanción enviada",
            text: `La sanción del cadete DNI ${sancion.cadeteDni} fue enviada a confirmación.`,
            icon: "success",
            confirmButtonText:
              "Aceptar",
          });

          socket.emit(
            "sancionEvent",
            sancion.cadeteDni
          );

          cerrarModal();
          obtieneMisSanciones();

          return;
        }

        Swal.fire({
          title:
            response?.data?.message ||
            "No se pudo actualizar",
          text:
            "Compruebe los datos e intente nuevamente.",
          icon: "error",
          confirmButtonText:
            "Aceptar",
        });
      } catch (error) {
        console.error(
          "Error pasando sanción a confirmar:",
          error
        );

        Swal.fire({
          title: "Error",
          text:
            "No se pudo enviar la sanción a confirmación.",
          icon: "error",
          confirmButtonText:
            "Aceptar",
        });
      }
    };

  // ============================================================
  // ELIMINAR
  // ============================================================

  const eliminaSancion = async (sancion) => {
    try {
      const confirmacion = await Swal.fire({
        title: "¿Eliminar sanción?",
        text:
          "Esta operación eliminará definitivamente el registro.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          "Eliminar definitivamente",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#b42318",
      });

      if (!confirmacion.isConfirmed) {
        return;
      }

      const token = obtenerToken();

      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/eliminaSancion/${sancion.id}`,
        {},
        {
          headers: {
            Authorization:
              `Basic ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        await Swal.fire({
          title: "Sanción eliminada",
          text: `La sanción del cadete DNI ${sancion.cadeteDni} fue eliminada.`,
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        socket.emit(
          "sancionEvent",
          sancion.cadeteDni
        );

        cerrarModal();
        obtieneMisSanciones();

        return;
      }

      Swal.fire({
        title:
          response?.data?.message ||
          "No se pudo eliminar",
        text:
          "Compruebe los datos e intente nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error(
        "Error eliminando sanción:",
        error
      );

      Swal.fire({
        title: "Error",
        text:
          "No se pudo eliminar la sanción.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  // ============================================================
  // SOCKET
  // ============================================================

  useEffect(() => {
    obtieneMisSanciones();

    const handleActualizacion = () => {
      obtieneMisSanciones();
    };

    socket.on(
      "estadoActualizable",
      handleActualizacion
    );

    return () => {
      socket.off(
        "estadoActualizable",
        handleActualizacion
      );
    };
  }, [
    refresca,
    obtieneMisSanciones,
  ]);

  // ============================================================
  // CATEGORIAS
  // ============================================================

  const categorias = useMemo(() => {
    return listadoSanciones.reduce(
      (acc, sancion) => {
        const estado =
          sancion?.estado ||
          "Sin estado";

        if (!acc[estado]) {
          acc[estado] = [];
        }

        acc[estado].push(sancion);

        return acc;
      },
      {}
    );
  }, [listadoSanciones]);

  // ============================================================
  // ABRIR DETALLE
  // ============================================================

  const manejoQueVeo = (sancion) => {
    setSancionSeleccionada(sancion);
    setVeoDatosSancion(true);
  };

  // ============================================================
  // HELPERS
  // ============================================================

  const nombreCompleto = (sancion) => {
    const apellido =
      sancion?.cadete
        ?.cadeteApellido || "";

    const nombre =
      sancion?.cadete
        ?.cadeteNombre || "";

    return `${apellido} ${nombre}`.trim();
  };

  const obtenerUbicacion = (
    sancion
  ) => {
    const compania =
      sancion?.cadete?.Seccion
        ?.Compania?.nombre;

    const seccion =
      sancion?.cadete?.Seccion
        ?.nombre;

    return [
      compania,
      seccion,
    ]
      .filter(Boolean)
      .join(" · ");
  };

  const obtenerPromocion = (
    sancion
  ) => {
    return (
      sancion?.cadete
        ?.Promocions?.[0]
        ?.nombre || null
    );
  };

  const formatearFecha = (
    fecha
  ) => {
    if (!fecha) {
      return "-";
    }

    const partes =
      String(fecha).split("-");

    if (partes.length === 3) {
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return fecha;
  };

  const configEstado = (estado) => {
    switch (estado) {
      case "Activa":
        return {
          indicador:
            "san-v2-indicator-red",
          badge:
            "san-v2-badge-red",
        };

      case "Para Confirmar":
        return {
          indicador:
            "san-v2-indicator-warning",
          badge:
            "san-v2-badge-warning",
        };

      case "Confirmada":
        return {
          indicador:
            "san-v2-indicator-green",
          badge:
            "san-v2-badge-green",
        };

      case "Finalizada":
      case "Finalizada Reclamada":
      case "Resuelto Reclamada":
        return {
          indicador:
            "san-v2-indicator-blue",
          badge:
            "san-v2-badge-blue",
        };

      case "Reclamada":
        return {
          indicador:
            "san-v2-indicator-purple",
          badge: "",
        };

      case "Anulada":
      case "Sin Efecto":
        return {
          indicador:
            "san-v2-indicator-red",
          badge:
            "san-v2-badge-red",
        };

      default:
        return {
          indicador:
            "san-v2-indicator-blue",
          badge:
            "san-v2-badge-blue",
        };
    }
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* MODAL DETALLE */}
      {/* ====================================================== */}

      {veoDatosSancion &&
        sancionSeleccionada && (
          <ModalSancion
            isOpen={veoDatosSancion}
            onClose={cerrarModal}
          >
            <div className="san-v2-modal">

              <div className="san-v2-modal-header">

                <span className="san-v2-modal-eyebrow">
                  PLIEGO DISCIPLINARIO
                </span>

                <h3>
                  Detalle de la sanción
                </h3>

                <p>
                  Información completa y estado
                  actual de la actuación
                  disciplinaria.
                </p>

              </div>

              {/* ============================================ */}
              {/* CADETE */}
              {/* ============================================ */}

              <div className="san-v2-selected-person">

                <div className="san-v2-avatar">
                  {sancionSeleccionada
                    ?.cadete
                    ?.cadeteApellido
                    ?.charAt(0)
                    ?.toUpperCase() ||
                    "C"}
                </div>

                <div className="san-v2-selected-info">

                  <span>
                    CADETE
                  </span>

                  <strong>
                    {nombreCompleto(
                      sancionSeleccionada
                    ) ||
                      `DNI ${sancionSeleccionada.cadeteDni}`}
                  </strong>

                  <small>
                    DNI{" "}
                    {
                      sancionSeleccionada.cadeteDni
                    }
                    {" · "}
                    Estado:{" "}
                    {
                      sancionSeleccionada.estado
                    }
                  </small>

                </div>

                <span
                  className={`san-v2-section-badge ${
                    configEstado(
                      sancionSeleccionada.estado
                    ).badge
                  }`}
                >
                  {
                    sancionSeleccionada.estado
                  }
                </span>

              </div>

              <div className="san-v2-form-container">
                <Sancion
                  sancionPasada={
                    sancionSeleccionada
                  }
                />
              </div>

            </div>
          </ModalSancion>
        )}

      {/* ====================================================== */}
      {/* CONTENIDO */}
      {/* ====================================================== */}

      <div style={{ width: "100%" }}>

        {/* ==================================================== */}
        {/* RESUMEN */}
        {/* ==================================================== */}

        <div className="san-v2-summary">

          <div className="san-v2-stat-card">

            <div className="san-v2-stat-icon">
              📑
            </div>

            <div>

              <span>
                Mis pliegos
              </span>

              <strong>
                {cargando
                  ? "..."
                  : listadoSanciones.length}
              </strong>

              <small>
                Sanciones generadas por usted
              </small>

            </div>

          </div>

          <div className="san-v2-stat-card">

            <div className="san-v2-stat-icon san-v2-stat-icon-warning">
              ⏳
            </div>

            <div>

              <span>
                En trámite
              </span>

              <strong>
                {
                  listadoSanciones.filter(
                    (s) =>
                      [
                        "Activa",
                        "Para Confirmar",
                        "Confirmada",
                        "Reclamada",
                      ].includes(
                        s?.estado
                      )
                  ).length
                }
              </strong>

              <small>
                Actuaciones aún abiertas
              </small>

            </div>

          </div>

          <div className="san-v2-stat-card">

            <div className="san-v2-stat-icon san-v2-stat-icon-confirm">
              ✓
            </div>

            <div>

              <span>
                Finalizadas
              </span>

              <strong>
                {
                  listadoSanciones.filter(
                    (s) =>
                      [
                        "Finalizada",
                        "Finalizada Reclamada",
                        "Resuelto Reclamada",
                      ].includes(
                        s?.estado
                      )
                  ).length
                }
              </strong>

              <small>
                Actuaciones concluidas
              </small>

            </div>

          </div>

        </div>

        {/* ==================================================== */}
        {/* ERROR */}
        {/* ==================================================== */}

        {error && (
          <section
            className="san-v2-section"
            style={{
              borderColor:
                "#fecdca",
            }}
          >
            <div
              className="san-v2-section-content"
              style={{
                padding:
                  "14px",
                color:
                  "#b42318",
              }}
            >
              {error}
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* CARGANDO */}
        {/* ==================================================== */}

        {cargando && (
          <section className="san-v2-section">
            <div
              className="san-v2-section-content"
              style={{
                padding:
                  "30px",
                textAlign:
                  "center",
                color:
                  "#667085",
              }}
            >
              Obteniendo sus sanciones...
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* VACIO */}
        {/* ==================================================== */}

        {!cargando &&
          listadoSanciones.length ===
            0 && (
            <section className="san-v2-section">

              <div
                className="san-v2-section-content"
                style={{
                  padding:
                    "35px 20px",
                  textAlign:
                    "center",
                }}
              >

                <div
                  className="san-v2-stat-icon san-v2-stat-icon-confirm"
                  style={{
                    margin:
                      "0 auto 10px",
                  }}
                >
                  ✓
                </div>

                <strong
                  style={{
                    display:
                      "block",
                    color:
                      "#344054",
                    fontSize:
                      "13px",
                  }}
                >
                  Sin sanciones registradas
                </strong>

                <span
                  style={{
                    display:
                      "block",
                    marginTop:
                      "4px",
                    color:
                      "#98a2b3",
                    fontSize:
                      "11px",
                  }}
                >
                  No tiene pliegos de sanción
                  generados.
                </span>

              </div>

            </section>
          )}

        {/* ==================================================== */}
        {/* CATEGORIAS */}
        {/* ==================================================== */}

        {!cargando &&
          Object.entries(
            categorias
          ).map(
            ([
              estado,
              sanciones,
            ]) => {
              const config =
                configEstado(estado);

              return (
                <section
                  key={estado}
                  className="san-v2-section"
                >

                  {/* ======================================== */}
                  {/* HEADER */}
                  {/* ======================================== */}

                  <div className="san-v2-section-header">

                    <div className="san-v2-section-title-group">

                      <div
                        className={`san-v2-indicator ${config.indicador}`}
                      />

                      <div>

                        <h2>
                          {estado}
                        </h2>

                        <p>
                          {
                            sanciones.length
                          }{" "}
                          {sanciones.length ===
                          1
                            ? "sanción"
                            : "sanciones"}{" "}
                          en este estado.
                        </p>

                      </div>

                    </div>

                    <span
                      className={`san-v2-section-badge ${config.badge}`}
                    >
                      {
                        sanciones.length
                      }
                    </span>

                  </div>

                  {/* ======================================== */}
                  {/* LISTADO */}
                  {/* ======================================== */}

                  <div className="san-v2-section-content">

                    {sanciones.map(
                      (
                        sancion,
                        index
                      ) => {
                        const ubicacion =
                          obtenerUbicacion(
                            sancion
                          );

                        const promocion =
                          obtenerPromocion(
                            sancion
                          );

                        const notificado =
                          Boolean(
                            sancion?.fechaNotificado
                          );

                        const tieneDescargo =
                          Boolean(
                            sancion?.descargo
                          );

                        return (
                          <div
                            key={
                              sancion?.id ||
                              index
                            }
                            className="san-v2-selected-person"
                            style={{
                              margin:
                                "6px",
                              background:
                                "#ffffff",
                            }}
                          >

                            {/* =============================== */}
                            {/* NUMERO */}
                            {/* =============================== */}

                            <div className="san-v2-avatar">
                              {index + 1}
                            </div>

                            {/* =============================== */}
                            {/* INFO */}
                            {/* =============================== */}

                            <div
                              className="san-v2-selected-info"
                              onClick={() =>
                                manejoQueVeo(
                                  sancion
                                )
                              }
                              style={{
                                cursor:
                                  "pointer",
                              }}
                            >

                              <span>
                                PLIEGO #
                                {sancion?.id ||
                                  "-"}
                              </span>

                              <strong>
                                {nombreCompleto(
                                  sancion
                                ) ||
                                  `DNI ${sancion?.cadeteDni}`}
                              </strong>

                              <small>
                                DNI{" "}
                                {
                                  sancion?.cadeteDni
                                }

                                {" · "}

                                Fecha:{" "}
                                {formatearFecha(
                                  sancion?.fechaFaltaCometida
                                )}

                                {sancion?.cadeteSede
                                  ? ` · Sede: ${sancion.cadeteSede}`
                                  : ""}

                                {ubicacion
                                  ? ` · ${ubicacion}`
                                  : ""}

                                {promocion
                                  ? ` · Promoción: ${promocion}`
                                  : ""}

                                {sancion?.cantidad
                                  ? ` · Cantidad: ${sancion.cantidad}`
                                  : ""}
                              </small>

                            </div>

                            {/* =============================== */}
                            {/* ESTADO */}
                            {/* =============================== */}

                            <div
                              style={{
                                display:
                                  "flex",
                                alignItems:
                                  "center",
                                justifyContent:
                                  "flex-end",
                                gap:
                                  "7px",
                                flexWrap:
                                  "wrap",
                              }}
                            >

                              {notificado && (
                                <span className="san-v2-section-badge san-v2-badge-green">
                                  ✓ Notificado
                                </span>
                              )}

                              {tieneDescargo && (
                                <span
                                  className="san-v2-section-badge san-v2-badge-red"
                                  onClick={() =>
                                    manejoQueVeo(
                                      sancion
                                    )
                                  }
                                  style={{
                                    cursor:
                                      "pointer",
                                  }}
                                >
                                  Tiene descargo
                                </span>
                              )}

                              {/* ============================= */}
                              {/* ACTIVA NOTIFICADA + DESCARGO */}
                              {/* ============================= */}

                              {sancion?.estado ===
                                "Activa" &&
                                notificado &&
                                tieneDescargo && (
                                  <>
                                    <button
                                      type="button"
                                      className="san-v2-btn-secondary"
                                      onClick={() =>
                                        anulaSancion(
                                          sancion
                                        )
                                      }
                                      style={{
                                        color:
                                          "#b42318",
                                      }}
                                    >
                                      Anular
                                    </button>

                                    <button
                                      type="button"
                                      className="san-v2-btn-primary"
                                      onClick={() =>
                                        pasaAConfirmarSancion(
                                          sancion
                                        )
                                      }
                                    >
                                      Pasar a confirmar
                                    </button>
                                  </>
                                )}

                              {/* ============================= */}
                              {/* ACTIVA SIN NOTIFICAR */}
                              {/* ============================= */}

                              {sancion?.estado ===
                                "Activa" &&
                                !notificado && (
                                  <>
                                    <span className="san-v2-section-badge san-v2-badge-warning">
                                      Esperando notificación
                                    </span>

                                    <button
                                      type="button"
                                      className="san-v2-btn-secondary"
                                      onClick={() =>
                                        eliminaSancion(
                                          sancion
                                        )
                                      }
                                      style={{
                                        color:
                                          "#b42318",
                                      }}
                                    >
                                      Eliminar
                                    </button>
                                  </>
                                )}

                              {/* ============================= */}
                              {/* OTROS ESTADOS */}
                              {/* ============================= */}

                              {sancion?.estado !==
                                "Activa" && (
                                <span
                                  className={`san-v2-section-badge ${config.badge}`}
                                >
                                  {
                                    sancion.estado
                                  }
                                </span>
                              )}

                              <button
                                type="button"
                                className="san-v2-btn-secondary"
                                onClick={() =>
                                  manejoQueVeo(
                                    sancion
                                  )
                                }
                              >
                                Ver
                              </button>

                            </div>

                          </div>
                        );
                      }
                    )}

                  </div>

                </section>
              );
            }
          )}

      </div>
    </>
  );
};

export default ObtieneSancionesUsuario;